import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  ticketsList: {
    paginated_results: [],
    not_filtered_tickets: [],
    counters: {
      total_tickets: 0,
      total_open_tickets: 0,
      total_in_progress_tickets: 0,
      total_completed_tickets: 0,
      total_closed_tickets: 0,
    },
    pagination: {
      active_page: 1,
      total_pages: 1,
      items_per_page: 10,
    },
    filter_options: {
      ticket_status: [],
      category: [],
      company_name: [],
      modified_at: [],
      created_at: [],
    },
  },
  currentTicketId: null,
  ticketCategories: [],
  ticketCreating: {
    projectId: null,
    userId: null,
  },
};

export const ticketsSlice = createSlice({
  name: "tickets",
  initialState: initialState,
  reducers: {
    getTicketsList: (state, action) => {
      state.ticketsList = action.payload;
    },
    getTicketDetails: (state, action) => {
      state.ticketDetails = action.payload;
    },
    changePageNumberTickets: (state, action) => {
      state.ticketsList.pagination.pageNumber = action.payload;
    },
    getCurrentTicketId: (state, action) => {
      state.currentTicketId = action.payload;
    },
    getTicketCategories: (state, action) => {
      state.ticketCategories = action.payload;
    },
    getTicketCreating: (state, action) => {
      state.ticketCreating = action.payload;
    },
  },
});

export const selectTicketsList = (state) => state.tickets.ticketsList;
export const selectTicketDetails = (state) => state.tickets.ticketsDetails;
export const selectSingleTicket = (state) => {
  const ticketId = Number(state?.tickets?.currentTicketId);
  return state?.tickets?.ticketsList?.not_filtered_tickets.find(
    (ticket) => ticket.id === ticketId
  );
};
export const selectTicketCategories = (state) => state.tickets.ticketCategories;
export const selectTicketCreating = (state) => state.tickets.ticketCreating;

export const {
  getTicketsList,
  getTicketDetails,
  changePageNumberTickets,
  getCurrentTicketId,
  getTicketCategories,
  getTicketCreating,
} = ticketsSlice.actions;
export default ticketsSlice.reducer;
